
































const ExcelJS = require("exceljs");

import { Component, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPagination } from "bootstrap-vue";
import Header from "@/components/Header.vue";
import EntityTabs from "@/components/EntityTabs.vue";
import ApptDetailedSearch from "@/components/report/ApptDetailedSearch.vue";
import ListView from "@/components/report/ApptDetailedList.vue";
import { ApptDetailedReportFilter } from "@/store/modules/types";
import App from "@/App.vue";
import ReportPdf from "@/components/schedule/ReportPdf.vue";
import moment from "moment";

@Component({
  components: {
    BPagination,
    Header,
    EntityTabs,
    ApptDetailedSearch,
    /*     Pager,
    CalendarView, */
    ListView,
    ReportPdf,
  },
  computed: {
    ...mapState("schedule", ["filter"]),
  },
})
export default class MembersReport extends Vue {
  calendarId: string = "";
  filter!: ApptDetailedReportFilter;
  pageRows: Array<any> = [];
  @Watch("filter", { deep: true })
  onFilterChanged() {
    this.getReport();
  }

  defaultFilter(): ApptDetailedReportFilter {
    this.$store.commit("schedule/SET_FILTER")
    return {
      //calendarList: [],
      //filterRecordApptList: [],
      filterBy: true,
      filterWithGap: "",
      origin: "",
      dateFrom: "",
      dateTo: "",
      //origenList: [],
      referenceDate: {
        to: null,
        from: null,
      },
      apptDate: {
        to: null,
        from: null,
      },
      calendarId: this.getDefaulthCalendar.id,
    };
  }

  async getReport() {
    this.$store.commit("main/SET_LOADING", true);
    const { calendarId } = this.filter;
    
    try {
      const data = await this.$store.dispatch(
        "schedule/getApptDetailedReport",
        calendarId
      );
      this.pageRows = data;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }

  get getDefaulthCalendar() {
    return this.$store.state.schedule.calendars[0];
  }

   get getCalendarSelected() {
    return this.$store.state.schedule.calendars.filter((c) => c.id === this.filter.calendarId)[0];
  }

  get getEntity() {
    return this.$store.state.auth.user.entities.filter(
      (e) => e.id == this.$store.state.auth.entityId
    )[0];
  }
  get columns(){
    var columns = ["First Name", "Last Name", "Phone", "Member ID", "Date", "Time", "Reason", "Priority", "Status", "User", "Origin", "Record Date", "Comments"];
    return columns;
  }
  get columnMap(){
    var column= {
        "First Name": "FirstName",
        "Last Name": "LastName",
        "Phone": "Phone",
        "Member ID": "InsurerMemberID",
        "Date": "Date",
        "Time": "Time",
        "Reason":"Reason",
        "Priority":"Priority",
        "Status":"Status",
        "User":"User",
        "Origin":"Origin",
        "Record Date":"RecordDate",
        "Comments":"comments"
      }
      return column;
  }
  get logo(){
    return require('../assets/wmpc_logo.png');
  }
  get TitleReport(){
    var reportTitle = "DETAILED APPOINTMENTS REPORT";
    return reportTitle;
  }
  get subtitle(){
    var subtitle = this.getCalendarSelected.name;
    return subtitle;
  }
  get reportDate(){
    return moment().format("MMM DD YYYY hh:mm A").toUpperCase();
  }
  get dateFrom(){
    return this.$store.state.schedule.filter.apptDate.from;
  }
  get dateto(){
    return this.$store.state.schedule.filter.apptDate.to;
  }
  get reportRangeDate(){
    return 'FROM ' + moment(this.dateFrom).format("MM/DD/YYYY") + ' TO ' + moment(this.dateto).format("MM/DD/YYYY")
  }
  get subTitleReport(){
    var calendar = this.getCalendarSelected ? this.getCalendarSelected.name : 'All Calendars';
    return calendar;
  }
  get getScheduleFilter(){
    return this.$store.state.schedule.filter;
  }
  get fileName(){
    var name = "detailed_appts_report_dateFrom_" + moment(this.dateFrom).format("MMDDYYYY") + '_dateTo_' + moment(this.dateto).format("MMDDYYYY");
    return name;
  } 
  get filterByDate(){
    return this.getScheduleFilter.filterBy == 1 ? "Filtered By Record Date" : "Filtered By Appointment Date";
  }
  get footerPDF(){
    var footer: string[] = [];
    //var total = 'Total: ' + this.pageRows.length + ' Appointments';
    //serv = 'service@waitingmed.com · www.waitingmed.com';
    //direction = 'Calle Luis Pales Matos FF-15, Levittown, PR 00949';
    return [
      'Total: ' + this.pageRows.length + ' Appointments',
      'service@waitingmed.com · www.waitingmed.com',
      'Calle Luis Pales Matos FF-15, Levittown, PR 00949'
    ];
    //return footer;
  }
  exportPDF(){
    const report = this.$refs.reportPdf as any; // cast para TS
      report.exportPDF();
  }
  exportExcel() {
    /*const store = this.$store;
    this.$store.commit("main/SET_LOADING", true);*/
    var reportTitle = this.TitleReport;//"APPOINTMENT DETAILED REPORT";
    var subtitle = this.subTitleReport;//this.getCalendarSelected.name;
    var fileName = this.fileName;
    var filterBy = this.filterByDate;
      //"appt_detailed_report_" + this.$moment().format("MMDDYYYY_hhmma");
    const reportDate = this.$moment()
      .format("MMM DD YYYY hh:mm A")
      .toUpperCase();
    const reportRangeDate = this.reportRangeDate;
    /*"FROM " +
      this.$moment().format("MM/DD/YYYY") +
      " TO " +
      this.$moment().format("MM/DD/YYYY");*/
    const medicalOffice = this.getEntity.name;
    //const calendar = this.report[0].Calendar.toUpperCase();
    // const waitingList = this.report[0].WaitingList.toUpperCase();
    //Patient	Phone	Member ID	Date	Time	Reason	Priority	Status	User	Origin	Record Date	Comments
    const header = [
      "Fisrt Name",
      "Last Name",
      "Phone",
      "Member ID",
      "Date",
      "Time",
      "Reason",
      "Priority",
      "Status",
      "User",
      "Origin",
      "Record Date",
      "Comments",
    ];
    const font = {
      name: "Calibri",
      family: 2,
      size: 16,
      underline: false,
      bold: true,
    };
    const alignment = {
      vertical: "middle",
      horizontal: "right",
    };
    const data: any = [];
    var total = 0;
    const moment: any = this.$moment;
    for (const appt of this.pageRows) {
      var row: any = [];
      row.push(appt.FirstName);
      row.push(appt.LastName);
      row.push(appt.Phone);
      row.push(appt.InsurerMemberID);
      row.push(moment(appt.Date).format("MM/DD/YYYY"));
      row.push(
        appt.Time
          ? moment(appt.Time, "HH:mm:ss").format("hh:mm A")
          : ""
      );
      row.push(appt.Reason);
      row.push(appt.Priority);
      row.push(appt.Status);
      row.push(appt.User);
      row.push(appt.Origin);
      row.push(
        appt.RecordDate
          ? moment(appt.RecordDate).format("MM/DD/YYYY")
          : ""
      );
      
      row.push(appt.comments);
      data.push(row);
    }
    //Create workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    workbook.creator = "PatientCare";
    workbook.lastModifiedBy = "PatientCare";
    workbook.created = new Date();
    workbook.modified = new Date();
    workbook.lastPrinted = new Date();

    const worksheet = workbook.addWorksheet("Report");

    //Add Row and formatting
    let reportTitleRow = (worksheet.getCell("H1").value = reportTitle);
    let reportDateRow = (worksheet.getCell("H2").value = reportDate);
    let medicalOfficeRow = (worksheet.getCell("H3").value = medicalOffice);
    let reportRangeDateRow = (worksheet.getCell("H4").value = reportRangeDate);
    let filterByDate = (worksheet.getCell("H5").value = filterBy);

    // Set font, size and style in title row.
    worksheet.mergeCells("H1:I1");
    worksheet.mergeCells("H2:I2");
    worksheet.mergeCells("H3:I3");
    worksheet.mergeCells("H4:I4");
    worksheet.mergeCells("H5:I5");

    worksheet.getCell("H1").font = font;
    worksheet.getCell("H2").font = font;
    worksheet.getCell("H3").font = font;
    worksheet.getCell("H4").font = font;
    worksheet.getCell("H5").font = font;

    worksheet.getCell("H1").alignment = alignment;
    worksheet.getCell("H2").alignment = alignment;
    worksheet.getCell("H3").alignment = alignment;
    worksheet.getCell("H4").alignment = alignment;
    worksheet.getCell("H5").alignment = alignment;

    //Add logo
    var img = new Image();

    img.onload = function () {
      var canvas: any = document.createElement("CANVAS");
      var ctx = canvas.getContext("2d");
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(this, 0, 0);
      var dataURL = canvas.toDataURL("image/png");
      canvas = null;

      //Add Image
      let logo = workbook.addImage({
        base64: dataURL,
        extension: "png",
      });

      worksheet.addImage(logo, "A1:B4");
      worksheet.mergeCells("A1", "B4");

      // Blank Row
      worksheet.addRow([]);

      //Add waitingList row
      let subTitleRow = worksheet.addRow([subtitle]); //subtitle
      worksheet.mergeCells("A6:I6");

      subTitleRow.eachCell((cell, number) => {
        cell.border = {
          top: {
            style: "thin",
            color: {
              argb: "87CEEB",
            },
          },
        };

        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 14,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      //Add Header Row
      let headerRow = worksheet.addRow(header);

      // Cell Style : Fill and Border
      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: {
            argb: "87CEEB",
          },
          bgColor: {
            argb: "FFFFFF",
          },
        };
        cell.border = {
          top: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      //add data
      worksheet.addRows(data);

      //column width
      worksheet.getColumn(1).width = 30;
      worksheet.getColumn(2).width = 30;
      worksheet.getColumn(3).width = 16;
      worksheet.getColumn(4).width = 16;
      worksheet.getColumn(5).width = 30;
      worksheet.getColumn(6).width = 16;
      worksheet.getColumn(7).width = 30;
      worksheet.getColumn(8).width = 30;
      worksheet.getColumn(9).width = 30;
      worksheet.getColumn(10).width = 30;
      worksheet.getColumn(11).width = 30;
      worksheet.getColumn(12).width = 30;
      worksheet.getColumn(13).width = 30;

      //Footer Row
      const footerFill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: "FFFFFF",
        },
      };

      var emptyRow = worksheet.addRow([]);
      worksheet.mergeCells(`A${emptyRow.number}:I${emptyRow.number}`);

      let footerRow = worksheet.addRow(["Total: " + data.length + " Appointments"]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:I${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      footerRow = worksheet.addRow([
        "service@waitingmed.com · www.waitingmed.com",
      ]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:I${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      footerRow = worksheet.addRow([
        "Calle Luis Pales Matos FF-15, Levittown, PR 00949",
      ]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:I${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      emptyRow = worksheet.addRow([]);
      worksheet.mergeCells(`A${emptyRow.number}:I${emptyRow.number}`);
      //save
      workbook.xlsx.writeBuffer().then((data) => {
        let blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        //app.saveAs(blob, fileName + '.xlsx');
        var url = window.URL.createObjectURL(blob);

        var doc = document.createElement("a");
        doc.href = url;
        doc.download = fileName + ".xlsx";
        doc.click();
        window.URL.revokeObjectURL(url);
      });
    };

    img.src = require("../assets/wmpc_logo.png");
  }

  clearFilter() {
    this.filter = this.defaultFilter();
    this.$store.commit("schedule/RESET_FILTER");
    this.getReport();
  }

  mounted() {
    this.getReport();
    this.$store.commit("schedule/SET_FILTER")
  }
}
